/**
 * @generated SignedSource<<d8cc0a48e78cd2bfcab143bb95835ec1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type bulkVariationEditor_Query$variables = {
  id: string;
};
export type bulkVariationEditor_Query$data = {
  readonly node: {
    readonly additionalCodes?: ReadonlyArray<{
      readonly code: string;
      readonly salesChannel: {
        readonly detail: {
          readonly properties: {
            readonly name: string | null;
            readonly storePosition: number | null;
          } | null;
        } | null;
        readonly ecommerceSettings: {
          readonly ecommerceName: ECommerce;
        } | null;
        readonly id: string;
      };
    }>;
    readonly code?: string;
    readonly name?: string;
    readonly salesChannel?: {
      readonly detail: {
        readonly properties: {
          readonly name: string | null;
          readonly storePosition: number | null;
        } | null;
      } | null;
      readonly ecommerceSettings: {
        readonly ecommerceName: ECommerce;
      } | null;
      readonly id: string;
    };
  } | null;
  readonly productMultipleVariantsRule: {
    readonly attributeCodes: ReadonlyArray<string>;
    readonly bulkAsNameAndNumberEnabled: boolean;
    readonly enableImportCSV: boolean;
    readonly nameAndNumberEnabled: boolean;
    readonly options: string | null;
    readonly skipOptionForNameAndNumber: boolean;
  };
};
export type bulkVariationEditor_Query = {
  response: bulkVariationEditor_Query$data;
  variables: bulkVariationEditor_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannelDetailProperties",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storePosition",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetail",
      "kind": "LinkedField",
      "name": "detail",
      "plural": false,
      "selections": [
        (v5/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v6/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "productId",
      "variableName": "id"
    }
  ],
  "concreteType": "ProductMultipleVariantsRule",
  "kind": "LinkedField",
  "name": "productMultipleVariantsRule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributeCodes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameAndNumberEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skipOptionForNameAndNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulkAsNameAndNumberEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableImportCSV",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "options",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v4/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetail",
      "kind": "LinkedField",
      "name": "detail",
      "plural": false,
      "selections": [
        (v5/*:: as any*/),
        (v4/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v6/*:: as any*/),
        (v4/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkVariationEditor_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductCode",
                "kind": "LinkedField",
                "name": "additionalCodes",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Model",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v8/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "bulkVariationEditor_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v9/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductCode",
                "kind": "LinkedField",
                "name": "additionalCodes",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v9/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Model",
            "abstractKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      },
      (v8/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "770850039e1f068b18a0f7345c8ebd33",
    "id": null,
    "metadata": {},
    "name": "bulkVariationEditor_Query",
    "operationKind": "query",
    "text": "query bulkVariationEditor_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      name\n      code\n      salesChannel {\n        id\n        detail {\n          properties {\n            name\n            storePosition\n          }\n          id\n        }\n        ecommerceSettings {\n          ecommerceName\n          id\n        }\n      }\n      additionalCodes {\n        code\n        salesChannel {\n          id\n          detail {\n            properties {\n              name\n              storePosition\n            }\n            id\n          }\n          ecommerceSettings {\n            ecommerceName\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  productMultipleVariantsRule(productId: $id) {\n    attributeCodes\n    nameAndNumberEnabled\n    skipOptionForNameAndNumber\n    bulkAsNameAndNumberEnabled\n    enableImportCSV\n    options\n  }\n}\n"
  }
};
})();

(node as any).hash = "39759593755af78c18902935e054bac1";

export default node;
